import type { ListAuditEntriesQueryParams } from '@/generated/http-clients/backofficeApiComponents'
import type { GetAuditLogsQueryParams } from '@/generated/http-clients/v3ApiComponents'

export const AUDIT_LOG_STATUSES = ['success', 'error', 'denied'] as const
export type AuditLogStatus = (typeof AUDIT_LOG_STATUSES)[number]
export const AUDIT_LOG_STEP_SIZE = 100

export interface AuditLogQuery {
  from?: number
  to?: number
  hiveId?: string
  orgId?: string
  licenseId?: string
  user?: string
  userId?: string
  status?: AuditLogStatus
}

type SharedFilters = Omit<AuditLogQuery, 'status'>

const SHARED_FILTER_KEYS = [
  'from',
  'to',
  'hiveId',
  'orgId',
  'licenseId',
  'user',
  'userId',
] as const satisfies readonly (keyof SharedFilters)[]

function definedSharedFilters(query: AuditLogQuery): SharedFilters {
  const filters: SharedFilters = {}
  for (const key of SHARED_FILTER_KEYS) {
    const value = query[key]
    if (value !== undefined) {
      Object.assign(filters, { [key]: value })
    }
  }
  return filters
}

export function toV3AuditParams(
  query: AuditLogQuery,
): Omit<GetAuditLogsQueryParams, 'page'> | null {
  const { status } = query
  if (status === 'denied') {
    return null
  }
  const params: Omit<GetAuditLogsQueryParams, 'page'> =
    definedSharedFilters(query)
  if (status !== undefined) {
    params.status = status
  }
  return params
}

export function toBackofficeAuditParams(
  query: AuditLogQuery,
): Omit<ListAuditEntriesQueryParams, 'cursor'> {
  const params: Omit<ListAuditEntriesQueryParams, 'cursor'> =
    definedSharedFilters(query)
  if (query.status !== undefined) {
    params.status = query.status
  }
  params.limit = AUDIT_LOG_STEP_SIZE
  return params
}
